




























































import { Vue, Component, Prop } from 'vue-property-decorator';
import T from '../../lang';
import * as ui from '../../ui';
import * as time from '../../time';

import omegaup_Markdown from '../Markdown.vue';

@Component({
  components: {
    'omegaup-markdown': omegaup_Markdown,
  },
})
export default class Summary extends Vue {
  @Prop() title!: string;
  @Prop() description!: string;
  @Prop() startTime!: Date;
  @Prop() finishTime!: Date;
  @Prop() scoreboard!: number;
  @Prop() windowLength!: null | number;
  @Prop() admin!: string;
  @Prop({ default: true }) showDeadlines!: boolean;
  @Prop({ default: true }) showRanking!: boolean;

  T = T;
  ui = ui;
  time = time;

  get duration(): number {
    if (!this.startTime || !this.finishTime) {
      return Infinity;
    }
    return this.finishTime.getTime() - this.startTime.getTime();
  }

  get eventWindowLength(): string {
    if (this.duration === Infinity) {
      return T.wordsUnlimitedDuration;
    }
    if (this.windowLength) {
      // Convert minutes to miliseconds
      return time.formatDelta(this.windowLength * (60 * 1000));
    }
    return time.formatDelta(this.duration);
  }

  get eventDescription(): string {
    return this.description || '';
  }
}
